import { comparator } from './string';

const EMPTY_ARRAY = [];

/**
 * Is the given array an untruthy value or is the array have length 0
 * @param {Array} array
 * @returns {boolean}
 */
const isEmptyArray = array => !Array.isArray(array) || array.length < 1;

/**
 * Return the last element of the provided array.
 * @param {Array} array
 * @returns {*}
 */
const getLastElement = array => array[array.length - 1];

const shuffle = array => {
  // https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
  let i;
  let j = 0;
  let temp = null;

  for (i = array.length - 1; i > 0; i -= 1) {
    j = Math.floor(Math.random() * (i + 1));
    temp = array[i];
    array[i] = array[j]; // eslint-disable-line no-param-reassign
    array[j] = temp; // eslint-disable-line no-param-reassign
  }

  return array;
};

/**
 * Take in an array of arrays and returns the shared elements (intersection)
 * @param arrays {Array[]} Array of Array's
 * @return {Array}
 */
const intersection = arrays =>
  isEmptyArray(arrays) || arrays.length < 2
    ? arrays
    : arrays.shift().filter(element => arrays.every(nArray => nArray.includes(element)));

/**
 * Sort an array alphabetically
 * @param {Array} array
 * @param {function({any}): String} getStringForComparison
 * @returns {Array}
 */
const sortAlphabetical = (array, getStringForComparison) =>
  array.sort((item1, item2) => {
    const str1 = getStringForComparison(item1).toLowerCase();
    const str2 = getStringForComparison(item2).toLowerCase();
    return comparator(str1, str2);
  });

/**
 * Convert an array of objects into an object of objects.
 * [{...a}, ..., {...n}] => {a: {...a}, ..., n: {...n}}
 * @param {Array} array
 * @param {String} key
 * @return {Object}
 */
const arrayToObject = (array, key = 'id') => {
  const object = {};
  array.forEach(a => {
    object[a[key]] = a;
  });

  return object;
};

const range = (start, end, step) => {
  const arr = [];

  for (let i = start; i <= end; i += step) {
    arr.push(i);
  }

  return arr;
};

export {
  shuffle,
  arrayToObject,
  isEmptyArray,
  intersection,
  getLastElement,
  EMPTY_ARRAY,
  sortAlphabetical,
  range,
};
